import { useAngularContext } from 'AngularContext';
import { type UserIdVerificationViewModelClass } from 'Cohorts';

export function useUserIdVerificationViewModel() {
    const $injector = useAngularContext();
    return $injector.get<UserIdVerificationViewModelClass>('UserIdVerificationViewModel');
}
